<template>
    <div>
        <div style="display: flex; justify-content: flex-end;margin-bottom: 12px;">
            <mc-select
                v-model="searchCityId"
                :source="cityList"
                placeholder="搜索城市"
                filterable
                clearable
                style="width: 200px;"
                @change="handleCitySearch"
            />
        </div>
        <div
            class="city-tab-row"
        >
            <!-- 可见城市 -->
            <div
                v-for="item in visibleCityList"
                :key="item.value"
                class="city-tab-item"
                :class="{ 'is-active': currentCityId === item.value }"
                @click="onCityChange(item.value)"
            >
                {{ item.label }}
            </div>
            <!-- 折叠/展开按钮 -->
            <div
                v-if="hiddenCityList.length > 0 && !isExpanded"
                class="city-tab-item city-tab-expand"
                @click="isExpanded = true"
            >
                (+{{ hiddenCityList.length }}) 展示
                <i class="el-icon-caret-bottom"></i>
            </div>
            <!-- 展开后显示隐藏的城市 -->
            <template v-if="isExpanded">
                <div
                    v-for="item in hiddenCityList"
                    :key="item.value"
                    class="city-tab-item"
                    :class="{ 'is-active': currentCityId === item.value }"
                    @click="onCityChange(item.value)"
                >
                    {{ item.label }}
                </div>
                <div
                    class="city-tab-item city-tab-expand"
                    @click="isExpanded = false"
                >
                    收起
                    <i class="el-icon-caret-top"></i>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
const DEFAULT_VISIBLE_COUNT = 16;

export default {
    name: 'CityTabs',
    props: {
        cityList: {
            type: Array,
            default: () => [],
            required: true,
        },
        value: {
            type: [String, Number],
            default: '',
        },
        visibleCount: {
            type: Number,
            default: DEFAULT_VISIBLE_COUNT,
        },
    },
    data() {
        return {
            currentCityId: this.value,
            currentYtType: '', // 当前选中的业态
            searchCityId: '', // 搜索框中的城市 ID
            isExpanded: false, // 城市列表是否展开
        };
    },
    computed: {
        // 默认显示的城市列表
        visibleCityList() {
            return this.cityList.slice(0, this.visibleCount);
        },
        // 折叠隐藏的城市列表
        hiddenCityList() {
            return this.cityList.slice(this.visibleCount);
        },
    },
    watch: {
        value(newVal) {
            this.currentCityId = newVal;
        },
    },
    created() {
        // 如果当前选中城市在隐藏列表中，自动展开
        this.ensureCurrentCityVisible();
    },
    methods: {
        // 城市 Tab 切换事件
        onCityChange(newCityId) {
            this.currentCityId = newCityId;
            // 通知父组件 v-model 更新
            this.$emit('input', newCityId);
        },
        // 搜索框选择城市后触发
        handleCitySearch(cityId) {
            if (cityId) {
                // 再切换到对应城市
                setTimeout(() => {
                    this.currentCityId = cityId;
                    // 如果目标城市在隐藏列表中，自动展开
                    this.ensureCurrentCityVisible();
                    // 通知父组件 v-model 更新
                    this.$emit('input', cityId);
                }, 0);
                // 清空搜索框
                this.searchCityId = '';
            }
        },
        // 确保当前选中城市可见（若在隐藏列表中则自动展开）
        ensureCurrentCityVisible() {
            const inHidden = this.hiddenCityList.some((item) => item.value === this.currentCityId);
            if (inHidden) {
                this.isExpanded = true;
            }
        },
    },
};
</script>
<style lang="scss" scoped >
.city-tab-row {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #e8e8e8;
    border-bottom: none;
}

.city-tab-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    height: 40px;
    min-width: 80px;
    cursor: pointer;
    border-right: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    transition: color 0.2s;
}

.city-tab-item:hover {
    color: #00b27a;
}

.city-tab-item.is-active {
    color: #00b27a;
    font-weight: 600;
    background: #f0faf6;
}

.city-tab-expand {
    color: #00b27a;
    white-space: nowrap;
}

.city-tab-expand i {
    margin-left: 2px;
    font-size: 12px;
}
</style>
